module.exports = __webpack_public_path__ + "img/what-happens-mobile-fr.6294f176.webp";